import React from "react";
import "./App.css";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
// import Deposit from "./pages/Deposit";
// import Warning from "./pages/Warning";
// import Result from "./pages/Result";
import NewPaymentGateway from "./components/NewPaymentGateway";
import NewPaymentGatewayCard from "./components/NewPaymentGatewayCard";
// import config from "devextreme/core/config";
// import { licenseKey } from "./assets/devextreme-license";

// config({ licenseKey });

function App() {
  return (
    <Router>
      <Routes>
        {/* <Route path="/" element={<Navigate to="/deposit" />} /> */}
        <Route path="/" element={<NewPaymentGateway />} />
        <Route path="/deposit" element={<NewPaymentGateway />} />
        <Route path="/cardDeposit" element={<NewPaymentGatewayCard />} />
        <Route path="*" element={<NewPaymentGateway />} />
        {/* <Route path="/warning" element={<Warning />} />
        <Route path="/result" element={<Result />} /> */}
      </Routes>
    </Router>
  );
}

export default App;
